import { IQuanLyHocPhanSelectRequest } from "../../../model/request/quyet-dinh/IQuanLyHocPhanSelectRequest";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import { ISMT_QuyetDinh_QuanLyHocPhan_Vm } from "./../../../model/respone/quyet-dinh/quan-ly-hoc-phan/ISMT_QuyetDinh_QuanLyHocPhan_Vm";

export const eQuanLyHocPhanActionsObj = {
  LOAD_START: {} as IQuanLyHocPhanSelectRequest,
  LOAD_SUCCESS: {} as ISMT_QuyetDinh_QuanLyHocPhan_Vm[],
  LOAD_ERRR: "",

  SAVE_START: {} as ISMT_QuyetDinh_QuanLyHocPhan_Vm[],
  SAVE_SUCCESS: {} as ISMT_QuyetDinh_QuanLyHocPhan_Vm,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: {} as ISMT_QuyetDinh_QuanLyHocPhan_Vm,
  DELETE_ERRR: "",

  SHOW_EDIT_MODAL: {} as ISMT_QuyetDinh_QuanLyHocPhan_Vm[],
  CLOSE_EDIT_MODAL: undefined,

  SELECTED_ID: [] as number[],
  CHANGE_REQUEST: {} as any,
};
export const eQuanLyHocPhanhActionIds = generateActionTypeIds(
  eQuanLyHocPhanActionsObj,
  "QUAN_LY_HOC_PHAN"
);
export type IQuanLyHocPhanhActionTypes = IGenericActionType<
  typeof eQuanLyHocPhanActionsObj,
  "QUAN_LY_HOC_PHAN"
>;
